import { twMerge } from "tailwind-merge";

import type { ReportingTableHeader } from "../../../types";
import { ReportingTableCheckbox } from "../checkbox";
import { type StickyPosition, getStickyStyle } from "../utils";
import { ReportingDownstreamHandlingBadge } from "./downstreamHandlingBadge";
import { ReportingSortIndicator } from "./sortIndicator";

type Props = {
  header: ReportingTableHeader;
  stickyPosition?: StickyPosition;
};

export const ReportingTableHeaderCell: React.FC<Props> = ({
  header,
  stickyPosition,
}) => {
  const nrSelected = header.nrSelected ?? 0;
  const nrTotal = header.nrTotal ?? 0;
  const allSelected = nrTotal > 0 && nrSelected === nrTotal;

  return (
    <th
      style={getStickyStyle(stickyPosition, { width: header.width })}
      onClick={header.sortable ? () => header.onClick?.(header.id) : undefined}
      className={twMerge(
        "sticky top-0 z-6 border-b border-b-[#E4DDDD] bg-[#FBFAF6] px-[14px] py-[12px] text-right align-bottom text-[11.5px] font-bold whitespace-nowrap text-[#9a958f] select-none",
        header.isFixedColumn && "z-8",
        header.sortable && "cursor-pointer",
        header.columnStyle,
      )}
    >
      {header.isCheckbox ? (
        <ReportingTableCheckbox
          checked={allSelected}
          indeterminate={nrSelected > 0 && !allSelected}
          onToggle={() => header.onClick?.(header.id)}
        />
      ) : (
        <>
          <span>
            {header.label}
            {header.sortable && (
              <ReportingSortIndicator
                isActive={header.isSortingActive}
                direction={header.sortingDirection}
              />
            )}
          </span>
          {header.downstreamHandling && (
            <ReportingDownstreamHandlingBadge
              name={header.downstreamHandling.name}
              color={header.downstreamHandling.color}
            />
          )}
        </>
      )}
    </th>
  );
};
